<div class="ui-g-12 no-padding">
	<div class="ui-g-12 content-section"
		[ngClass]="{'ui-g-12': siteLayoutService.displayTabletView,
			'no-padding': siteLayoutService.displayTabletView}">
		<div class="ellipsis-text agency-section">
			<strong class="data-format">
				{{context.source.selectedItem.organizationName.displayName}}
			</strong>
		</div>
		<div class="section-margin">
			<app-dynamic-formly
				[dataSet]="context.source.selectedItem"
				[layoutSchema]="context.source.formlyDefinitions.layout"
				(validityChanged)="context.source.validExpandComponentChanged($event)">
			</app-dynamic-formly>
		</div>
	</div>
</div>